import React from "react";
import ReactDOM from "react-dom";
import * as Sentry from "@sentry/react";
import { Integrations } from "@sentry/tracing";
import { BrowserRouter } from "react-router-dom";
import App from "./App";
import AuthService from "./services/auth.service";
import NotificationSocket from "./pages/Notification/NotificationSocket";
import OndemandSocket from "./pages/TeleconsultOnDemand/OndemandSocket";
import { store } from "./app/store";
import { Provider } from "react-redux";
import { AudioProvider } from './app/OnDemandAlertContext';

Sentry.init({
  dsn: "https://d2560229c2ea4ddcaabe4cfa8a56ad69@o1069318.ingest.sentry.io/6154151",
  integrations: [new Integrations.BrowserTracing()],
  environment: process.env.REACT_APP_SENTRY_ENVIRONMENT,
  enabled: process.env.REACT_APP_SENTRY_ENVIRONMENT !== "development",

  initialScope: {
    user: AuthService.getCurrentUserSentryParams(),
  },

  // Set tracesSampleRate to 1.0 to capture 100%
  // of transactions for performance monitoring.
  // We recommend adjusting this value in production
  tracesSampleRate: 0.0,
});
const currentUser = AuthService.getCurrentUser();
const initialPath = window.location.pathname;

ReactDOM.render(
  <BrowserRouter>
    <Provider store={store}>
      <AudioProvider>
        <App />
      </AudioProvider>
      {currentUser && initialPath !== "/eb/video" && <NotificationSocket />}
      {currentUser && initialPath !== "/eb/video" && <OndemandSocket />}
    </Provider>
  </BrowserRouter>,
  document.getElementById("root")
);
